import { render, staticRenderFns } from "./legalEntities.vue?vue&type=template&id=79a56404"
import script from "./legalEntities.ts?vue&type=script&lang=js&external"
export * from "./legalEntities.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports